import css from 'styled-jsx/css'
import { colors } from '../../styles'
import { transparentize } from '../../utils/colors'

export default css`
.ProgrammeHeader {
  background-color: ${colors.baseBg};
  position: relative;
  overflow: hidden;
  padding-top: 8px;
}
.ProgrammeHeader :global(.button:hover){

}
.hero-container{
  aspect-ratio: 1 / 1;
}
figure {
  margin: 0;
  overflow: hidden;
  position: relative;
  height: 235px;
}

figure::after {
  background-image: linear-gradient(
    to top,
    ${colors.baseBg} 0,
    ${colors.baseBg} 20%,
    ${transparentize(colors.baseBg, 0)} 100%
  );
  background-position: center bottom;
  background-repeat: repeat-x;
  background-size: 100% 100%;
  bottom: 0;
  content: '';
  display: block;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.ProgrammeHeader
:global(.Image) {
width: 100%;
    aspect-ratio: 1 / 1;
    height: 100vw;
    padding: 1px;
}

.programme-information {
  margin-top: -120px;
  padding: 40px 16px 8px;
  position: relative;
}

.svod-exclusive-warning {
  padding-top: 8px;
}

.upgrade-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 32px;
  gap: 10px;
  cursor: pointer;
  width: auto;
  height: 44px;
  border-radius: 8px;
  border: 0;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.3em;
  line-height: 20px;
  bottom: 80px;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
  color: ${colors.baseBg};
  background: ${colors.primaryText};
  margin-top: 8px;
  margin-bottom: 4px;
}

h1 {
  color: ${colors.primaryText};
  display: inline-block;
  font-size: 24px;
  font-weight: 800;
  padding-bottom: 4px;
}

.available-episodes {
  color: ${colors.textHoverPurple};
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 1em;
  margin-top: 1em;
}

.programme-description {
  color: ${colors.secondaryText};
  display: none;
}

@media (min-width: 768px) {
  .hero-container{
    aspect-ratio: 16 / 9;
    padding-bottom: 32px;
  }
  .ProgrammeHeader
  :global(.Image) {
    right: -18%;
    top: -1px;
    width: 90%;
    aspect-ratio: 16 / 9;
    height: auto;
  }
  figure {
    width: 60%;
    height: 100%;
  }

  figure::after {
    background-image: linear-gradient(
      to right,
      ${colors.baseBg} 0,
      ${colors.baseBg} 2.5%,
      ${transparentize(colors.baseBg, 0)} 30%,
      ${transparentize(colors.baseBg, 0)} 70%,
      ${colors.baseBg} 97.5%,
      ${colors.baseBg} 100%
    );
    box-shadow: inset 0 -20px 40px 0 ${colors.baseBg};
  }

  .programme-information {
    margin-top: 0;
    padding-bottom: 24px;
    width: 50%;
  }

  h1 {
    font-size: 40px;
  }

  .programme-description {
    display: block;
  }
}

@media (min-width: 900px) {
  .programme-information {
    padding-left: 32px;
    padding-right: 32px;
  }
}
`
